import React from 'react';
import classnames from 'classnames';
import { FormattedMessage } from 'translations';
import { Field } from 'redux-form';
import { Layout, Flex } from 'app/components/base/Layout';
import TransitionInput from 'app/components/base/TransitionInput';
import { getPlaceholderHint } from 'app/utils/togglers';
import config from 'config';
import { useEventOnce } from 'app/hooks';

import {
  FIRST_NAME_FIELD_NAME,
  LAST_NAME_FIELD_NAME,
  EMAIL_FIELD_NAME,
  EMAIL_CONFIRMATION_FIELD_NAME,
} from 'app/constants';

import style from './style.css';

const messages = {
  email: { id: 'USER.EMAIL' },
  emailAgain: { id: 'BOOK_TRIP.CONTACT_INFO.EMAIL_CONFIRMATION' },
  firstName: { id: 'USER.FIRST_NAME' },
  lastName: { id: 'USER.LAST_NAME' },
};

const fieldSize = {
  '> mobile': 50,
  mobile: 100,
};

const UserData = ({ className, onFormFillStart }) => {
  const { handleEventOnce } = useEventOnce(onFormFillStart);

  return (
    <Layout className={classnames(style.container, className)}>
      <Flex
        size={fieldSize}
        className={classnames(style.field, style['field--left'])}
      >
        <Field
          compact
          component={TransitionInput}
          name={FIRST_NAME_FIELD_NAME}
          type="text"
          label={<FormattedMessage {...messages.firstName} />}
          labelClassName={style['field--top']}
          upwards
          keepLabel={config.HINT_PLACEHOLDERS_SHOW}
          placeholder={getPlaceholderHint(FIRST_NAME_FIELD_NAME)}
          onChange={handleEventOnce}
        />
      </Flex>
      <Flex size={fieldSize} className={style.field}>
        <Field
          compact
          component={TransitionInput}
          name={LAST_NAME_FIELD_NAME}
          type="text"
          label={<FormattedMessage {...messages.lastName} />}
          labelClassName={style['field--top']}
          upwards
          keepLabel={config.HINT_PLACEHOLDERS_SHOW}
          placeholder={getPlaceholderHint(LAST_NAME_FIELD_NAME)}
          onChange={handleEventOnce}
        />
      </Flex>
      <Flex
        size={fieldSize}
        className={classnames(style.field, style['field--left'])}
      >
        <Field
          compact
          component={TransitionInput}
          name={EMAIL_FIELD_NAME}
          type="email"
          label={<FormattedMessage {...messages.email} />}
          upwards
          keepLabel={config.HINT_PLACEHOLDERS_SHOW}
          placeholder={getPlaceholderHint(EMAIL_FIELD_NAME)}
          onChange={handleEventOnce}
        />
      </Flex>
      <Flex size={fieldSize} className={style.field}>
        <Field
          compact
          component={TransitionInput}
          name={EMAIL_CONFIRMATION_FIELD_NAME}
          type="email"
          label={<FormattedMessage {...messages.emailAgain} />}
          upwards
          keepLabel={config.HINT_PLACEHOLDERS_SHOW}
          placeholder={getPlaceholderHint(EMAIL_CONFIRMATION_FIELD_NAME)}
          onChange={handleEventOnce}
        />
      </Flex>
    </Layout>
  );
};

// TODO: move to Flow types
// UserData.propTypes = {
//   className: PropTypes.string
// };

export default UserData;
